import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

/*
 * Liste principali di una pagina (prop `pageList`): i pulsanti della lista (Nuovo…,
 * Importa, Esporta…) non stanno nel box ma sulla riga del titolo della pagina, a destra.
 * Ci arrivano con un portal nello slot che SidPageHeader tiene sempre pronto, cosi'
 * restano componenti della lista (props e stato sempre aggiornati).
 */
export const usePageHeaderActionsSlot = (enabled) => {
	const [slot, setSlot] = useState(null);
	useEffect(() => {
		setSlot(enabled ? document.getElementById('sid-page-header-actions') : null);
	}, [enabled]);
	return slot;
};

export const PageHeaderActions = ({ slot, children }) => (slot ? createPortal(children, slot) : null);
